import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=b364e3d4&scoped=true&"
import script from "./Pagenation.vue?vue&type=script&lang=js&"
export * from "./Pagenation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b364e3d4",
  null
  
)

export default component.exports